import { FC } from 'react';
import { useArticleTitle } from '@article/shared/utils/use-article-title';
import { useArticleDescription } from '@article/shared/utils/use-article-description';
import { useArticleKeywords } from '@article/shared/utils/use-article-keywords';

export const ArticleTDK: FC = () => {
  const title = useArticleTitle();
  const description = useArticleDescription();
  const keywords = useArticleKeywords();

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords.join(',')} />
    </>
  );
};
